/*
 * File: index.ts
 * Desc: 工具集合
 * File Created: 2019-09-29 11:16:33
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */

/**
 * 获取两个数组的交集
 * @param arr1 数组1
 * @param arr2 数组2
 */
function intersectionArr(arr1: string[], arr2: string[]): string[] {
    const _temp: string[] = [];
    arr1.forEach((v1: string) => {
        if (arr2.indexOf(v1) !== -1) _temp.push(v1);
    });
    return _temp;
}

/**
 * 权限许可验证
 * @param permits 所有的权限许可
 * @param require 需要的权限许可
 * @param every 是否检查所有的许可
 */
export const includePermit = (
    permits: string[],
    require: string[] | null,
    every: boolean | undefined
): boolean => {
    if (!require || require.length < 1) return true;
    const _intersection = intersectionArr(require, permits);
    // every存在时，交集必须包含require所有数组
    return every ? _intersection.length === require.length : _intersection.length > 0;
};

/**
 * 数据类型检测，String，Number，Array...
 */
export class PrototypeCheck {
    static getPrototype(value: any): string {
        return Object.prototype.toString.call(value);
    }

    static checkProtoType(value: any, prototype: string): boolean {
        return this.getPrototype(value) === prototype;
    }

    /**
     * 是否String类型
     * @param value
     */
    static isString(value: any): boolean {
        return this.checkProtoType(value, '[object String]');
    }

    /**
     * 是否Number类型
     * @param value
     */
    static isNumber(value: any): boolean {
        return this.checkProtoType(value, '[object Number]');
    }

    /**
     * 是否Array类型
     * @param value
     */
    static isArray(value: any): boolean {
        return this.checkProtoType(value, '[object Array]');
    }

    /**
     * 是否Function类型
     * @param value
     */
    static isFunction(value: any): boolean {
        return this.checkProtoType(value, '[object Function]');
    }
}

/**
 * 生成唯一的key
 * @param a
 */
export function uuid(a?: number) {
    return a
        ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
        : (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
}
